
import { Client } from './clientTypes';
import { financeClients } from './financeClients';
import { retailClients } from './retailClients';
import { serviceClients } from './serviceClients';
import { manufacturingClients } from './manufacturingClients';
import { partners } from './partnersData';
import { atsIntegrations } from './atsIntegrationsData';

// Combine all client lists into a single array
export const clients: Client[] = [
  ...financeClients,
  ...retailClients,
  ...serviceClients,
  ...manufacturingClients,
];

// Re-export the Client interface
export type { Client };

// Export individual client category lists
export {
  financeClients,
  retailClients,
  serviceClients,
  manufacturingClients,
  partners,
  atsIntegrations,
};
